import * as React from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  showCondition: boolean;
  deps?: React.DependencyList;
}

export const Portal: React.FC<React.PropsWithChildren<PortalProps>> = ({
  showCondition,
  deps = [],
  children,
}) => {
  const [showPortal, setShowPortal] = React.useState<boolean>(false);

  React.useEffect(() => {
    /*
        kind of hacky solution - portal won't get the reference 
        to the element on initial render, so we want to wait for DOM
     */
    if (showCondition) {
      setShowPortal(true);
    } else {
      setShowPortal(false);
    }
  }, deps);

  if (!showPortal) {
    return null;
  }

  const portals = Array.from(document.getElementsByClassName('conditional-blur')).map(root => {
    return createPortal(children, root);
  });

  return <>{portals}</>;
};
